import React from 'react'
import ReactDOM from 'react-dom'
import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'
import { config } from '../../../config'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import { scrollTop, getItemById, getGreetHour } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { AppView, AppHeader, AppContent, AppContainer } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
import { Heading, Animation, Page, PageTitle } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import NavigationCards from './components/NavigationCards'
import { withHome } from '@brainstud/react-tbl/themes/pgw/v1/containers'

class HomeView extends React.Component {
  constructor(props) {
    super(props)

    this.elms = []
  }

  componentDidMount() {
    this.props.app.triggerTheme('default')
    this.props.app.setLocation({ label: 'home' })

    this.checkProgress()
  }

  componentWillUnmount() {
    this.props.app.didProgress()
  }

  checkProgress() {
    // Redirect intro page if first time
    if(this.props.navigation[0].progress.progress === 0 && config.introductionPage) {
      const first = this.props.navigation[0]

      switch(first.type) {
        case "page":
          const page = getItemById(this.props.pages, first.pageId)
          this.props.history.push(Routes.to('page', { page: page.slug }))
          break

        case "chapter":
          const chapter = getItemById(this.props.chapters, first.chapterId)
          this.props.history.push(Routes.to('chapter', { chapter: chapter.slug }))
          break

        default:
          return false
      }
    }

    // Animate progress when exists
    else {
      setTimeout(() => {
        let top = 0

        if(this.props.app.checkProgress) {
          if(this.props.app.checkProgress !== 1) {
            const domNode = ReactDOM.findDOMNode(this.elms[this.props.app.checkProgress-1])
            if(domNode) {
              top = domNode.getBoundingClientRect().top - 30
            }
          }

          // setTimeout(this.props.accountActions.updateLastProgress, 800)
        }

        scrollTop(top, 600)
      }, 0)
    }
  }

  render() {
    return (
      <AppView name="Home">
        <AppHeader />

        <AppContent>
          <Page>
            <AppContainer>
              <Animation name="slideInDown" delay={100}>
                <PageTitle>
                  <Heading h1>{translate('home.title', { greet: translate(`greet.h${getGreetHour()}`), name: this.props.user.name })}</Heading>
                  <Heading em>{translate('home.description')}</Heading>
                </PageTitle>
              </Animation>
            </AppContainer>

            <Animation name="appear" delay={200}>
              <NavigationCards
                setElms={(idx, el) => this.elms[idx] = el}
                translateTo={this.props.app.checkProgress}
                navigation={this.props.navigation}
                chapters={this.props.chapters}
                pages={this.props.pages}
                user={this.props.user} />
            </Animation>
          </Page>
        </AppContent>
      </AppView>
    )
  }
}

export default withHome(HomeView)
